import {useEffect, useRef} from 'react';

export const useFocusOnFirstLevelClickedButton = (
  isFirstCategoryLevelShown: boolean,
) => {
  const previousFocusedElement = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (isFirstCategoryLevelShown) {
      const tabindex = previousFocusedElement.current?.getAttribute('tabindex');
      if (tabindex === '-1') {
        previousFocusedElement.current?.querySelector('a')?.focus();
      } else {
        previousFocusedElement.current?.focus();
      }
    }
  }, [isFirstCategoryLevelShown]);

  return previousFocusedElement;
};

export const useFocusOnFirstButtonElement = () => {
  const listRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.querySelector('a')?.focus();
    }
  }, [listRef.current]);

  return listRef;
};
